import { FC, useContext } from 'react'
import { ToolbarButton } from './ToolbarButton'
import { useToggle } from '../../hooks/useToggle'
import { InternalContext } from '../contexts/InternalContext'
import { useHotkey } from '../../hooks/useHotkey'
import SvgAutoplay from '../../components/icons/Autoplay'
import { AppContext } from '../../AppContext'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { CutterActionType } from '../enums/CutterActionType'

export const ToolbarAutoplay: FC = () => {
  const { hotkeysEnabled } = useContext(AppContext)
  const { autoplayEnabled, setAutoplayEnabled } = useContext(InternalContext)
  const callback = useToggle(setAutoplayEnabled)

  useHotkey(
    (event) => event.shiftKey && (event.keyCode === 80 || event.key === 'P'),
    () => {
      logger.log(LogActionType.HotkeyPress, { type: CutterActionType.Autoplay })

      callback()
    },
    hotkeysEnabled,
  )

  return (
    <ToolbarButton
      icon={<SvgAutoplay />}
      hotkey="Shift+P"
      active={autoplayEnabled}
      onClick={() => {
        logger.log(LogActionType.ToolbarButtonClick, { type: CutterActionType.Autoplay })

        callback()
      }}
      style={{ marginLeft: 'auto' }}
    >
      Autoplay
    </ToolbarButton>
  )
}
